import template from './sw-product-detail.html.twig'

const { Criteria } = Shopware.Data

Shopware.Component.override('sw-product-detail', {
    template,

    computed: {
        // Add zeoProductUpsellings relation to the criteria to ensure the relation is loaded
        productCriteria() {
            const criteria = this.$super('productCriteria')
            criteria
                .getAssociation('zeoProductUpsellings')
                .addSorting(Criteria.sort('position', 'ASC'))
            criteria
                .getAssociation(
                    'zeoProductUpsellings.upsellingAssignedProducts'
                )
                .addSorting(Criteria.sort('position', 'ASC'))
                .addAssociation('product')
                .getAssociation('product')
                .addAssociation('options.group')

            return criteria
        }
    }
})
